import React from 'react'

import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

const Dashboard = () => {
  return (
    <Grid item>
      <Typography sx={{ textAlign: 'center' }} variant='h1'>
        Welcome to SUPERconnection
      </Typography>
      <Typography sx={{ textAlign: 'center' }}>
        Use the navigation on the left to select an option
      </Typography>
    </Grid>
  )
}

export default Dashboard
